import React, { useEffect } from "react";
import "./Nav.css";
import { useSelector } from "react-redux";
import config from "./config";
import NavSection from "../nav-section";
import { Box } from "@mui/material";
import Scrollbar from "../scrollbar";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

function Nav({ openNav, onCloseNav }) {
  const { user } = useSelector((state) => state.auth);
  const storeId = user?.storeId;
  const navConfig = config(user?.user_role_code);
  const { pathname } = useLocation();

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        "& .simplebar-content": {
          height: 1,
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <NavSection data={navConfig} />
    </Scrollbar>
  );

  return (
    <>
      <Box className="nav-wrapper">
        <Box
          className="nav-wrapper-content"
          style={{
            width: openNav ? 90 : 0,
          }}
        >
          {renderContent}
        </Box>
      </Box>
    </>
  );
}

export default Nav;
